import { reactive } from 'vue'
import { v4 } from 'uuid'

/**
 * 引数に指定した名前の乱数をリアクティブな値として生成する
 * html上で id /forに指定する値として利用することができる
 * @param ids 利用したいIDの名前の配列
 * @return 引数で指定した値をキーに持つ乱数のMap
 */
export default function useId<T extends string>(ids: T[]): { [K in T]: string } {
  return reactive(
    ids.reduce((acc, cur) => {
      acc[cur] = `a${v4()}`
      return acc
    }, Object.create(null)),
  )
}
